import { render, staticRenderFns } from "./TheBottomNavigation.vue?vue&type=template&id=6d9f93f7&"
import script from "./TheBottomNavigation.vue?vue&type=script&lang=js&"
export * from "./TheBottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TheBottomNavigation.vue?vue&type=style&index=0&id=6d9f93f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports